import { apiClient } from "../utils/apiClient";
import { ORGANIZER_EVENTS_URL } from "../config/api";

export interface StageSales {
    stageId: string;
    name: string;
    price: number;
    active: boolean;
    // Tickets of the stage set by the organizer, courtesy tickets included
    capacity: number;
    // Courtesy tickets: they come out of the capacity and are not sold
    courtesyQuantity?: number;
    // Paid and confirmed
    sold: number;
    // Held by buyers who are paying right now (released if they do not pay)
    reserved: number;
    // What can still be bought
    available: number;
}

export interface EventSales {
    eventId: string;
    name: string;
    startDate?: string;
    endDate?: string;
    location?: string;
    status: 'ACTIVE' | 'FINISHED' | 'CANCELLED';
    stages: StageSales[];
}

export class SalesUnavailableError extends Error {
    constructor() {
        super('No fue posible consultar las ventas');
        this.name = 'SalesUnavailableError';
    }
}

export const organizerSalesService = {
    // Every published event of the organizer, active ones first; drafts have no sales
    async getMySales(): Promise<EventSales[]> {
        const response = await apiClient(`${ORGANIZER_EVENTS_URL}/sales`, { cache: 'no-store' });
        if (!response.ok) {
            throw new SalesUnavailableError();
        }
        return await response.json();
    }
};
